import { AdminRolesEnum } from '@/dashboard/enums/admin-roles';
import Merchants from '@/dashboard/admin/scenes/Merchants';
import Merchant from '@/dashboard/admin/scenes/Merchant';
import MerchantsUsage from '@/dashboard/admin/scenes/MerchantsUsage';
import Users from '@/dashboard/admin/scenes/Users';
import Pages from '@/dashboard/admin/scenes/Pages';
import PageCompare from '@/dashboard/admin/scenes/PageCompare';
import PagePrompts from '@/dashboard/admin/scenes/PagePrompts';
import Plans from '@/dashboard/admin/scenes/Plans';
import Payments from '@/dashboard/admin/scenes/Payments';
import Bookings from '@/dashboard/admin/scenes/Bookings';
import Subscriptions from '@/dashboard/admin/scenes/Subscriptions';
import Submissions from '@/dashboard/admin/scenes/Submissions';
import Templates from '@/dashboard/admin/scenes/Templates';
import Template from '@/dashboard/admin/scenes/Template';
import TemplateAdd from '@/dashboard/admin/scenes/TemplateAdd';
import TemplateCategories from '@/dashboard/admin/scenes/TemplateCategories';
import TemplateCategory from '@/dashboard/admin/scenes/TemplateCategory';
import TemplateCategoryAdd from '@/dashboard/admin/scenes/TemplateCategoryAdd';
import HelpCenterSearchIntents from '@/dashboard/admin/scenes/HelpCenterSearchIntents';
import AdminActions from '@/dashboard/admin/scenes/Actions';
import StatisticLogs from '@/dashboard/admin/scenes/StatisticLogs';
import MetricLogs from '@/dashboard/admin/scenes/MetricLogs';
import IntegrationLogs from '@/dashboard/admin/scenes/IntegrationLogs';
import CalculatePageMetadata from './scenes/CalculatePageMetadata';
import BullBoard from './scenes/BullBoard';
import Themes from './scenes/Themes';
import ApiKeys from './scenes/ApiKeys';
import OAuthTokens from './scenes/OAuthTokens';
import Webhooks from './scenes/Webhooks';
import AiUsage from './scenes/AiUsage';
import AiUsageStore from './scenes/AiUsage/AiUsageStore';
import LinkInBios from './scenes/LinkInBios';
import BrandFetches from './scenes/BrandFetches';
import EmailTemplates from './scenes/EmailTemplates';

export const ADMIN_ROUTES = [
  {
    path: '/admin/merchants',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Merchants,
  },
  {
    path: '/admin/merchants/:sellerId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Merchant,
  },
  {
    path: '/admin/merchants-usage',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: MerchantsUsage,
  },
  {
    path: '/admin/users',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Users,
  },
  {
    path: '/admin/pages',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: Pages,
  },
  {
    path: '/admin/pages/compare/:pageId',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: PageCompare,
  },
  {
    path: '/admin/pages/compare',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: PageCompare,
  },
  {
    path: '/admin/page-prompts',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: PagePrompts,
  },
  {
    path: '/admin/ai-usage',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: AiUsage,
  },
  {
    path: '/admin/ai-usage/stores/:sellerId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: AiUsageStore,
  },
  {
    path: '/admin/link-in-bio',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: LinkInBios,
  },
  {
    path: '/admin/payments',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Payments,
  },
  {
    path: '/admin/bookings',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Bookings,
  },
  {
    path: '/admin/subscriptions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Subscriptions,
  },
  {
    path: '/admin/submissions',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.SUPPORT],
    exact: true,
    component: Submissions,
  },
  {
    path: '/admin/plans',
    roles: [AdminRolesEnum.ADMIN],
    exact: true,
    component: Plans,
  },
  {
    path: '/admin/themes',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Themes,
  },
  {
    path: '/admin/api-keys',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: ApiKeys,
  },
  {
    path: '/admin/oauth-tokens',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: OAuthTokens,
  },
  {
    path: '/admin/webhooks',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Webhooks,
  },
  {
    path: '/admin/templates',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Templates,
  },
  {
    path: '/admin/templates/new',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateAdd,
  },
  {
    path: '/admin/templates/:templateId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: Template,
  },
  {
    path: '/admin/template-categories',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategories,
  },
  {
    path: '/admin/template-categories/new',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategoryAdd,
  },
  {
    path: '/admin/template-categories/:categoryId',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.EDITOR, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: TemplateCategory,
  },
  {
    path: '/admin/help-center-search-intents',
    roles: [
      AdminRolesEnum.ADMIN,
      AdminRolesEnum.SUPPORT,
      AdminRolesEnum.EDITOR,
      AdminRolesEnum.DEVELOPER,
    ],
    exact: true,
    component: HelpCenterSearchIntents,
  },
  {
    path: '/admin/actions',
    roles: [AdminRolesEnum.ADMIN],
    exact: true,
    component: AdminActions,
  },
  {
    path: '/admin/statistic-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: StatisticLogs,
  },
  {
    path: '/admin/metric-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: MetricLogs,
  },
  {
    path: '/admin/integration-logs',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: IntegrationLogs,
  },
  {
    path: '/admin/calculate-page-metadata',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: CalculatePageMetadata,
  },
  {
    path: '/admin/queues',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: BullBoard,
  },
  {
    path: '/admin/email-templates',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: EmailTemplates,
  },
  {
    path: '/admin/brand-fetches',
    roles: [AdminRolesEnum.ADMIN, AdminRolesEnum.DEVELOPER],
    exact: true,
    component: BrandFetches,
  },
];
